// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-info-menu {
  position: absolute;
  top: 45px;
  left: 10px; /* Слева */
  display: flex;
  flex-direction: column;
  gap: 4px; /* Чуть больше промежуток */
  background-color: rgba(20, 20, 20, 0.7); /* Темный фон */
  padding: 8px;
  border-radius: 5px;
  z-index: 1000;
  color: #e0e0e0; /* Светло-серый текст */
  font-size: 10px;
  font-family: 'Courier New', Courier, monospace; /* Моноширинный шрифт */
  max-width: 200px;
  max-height: calc(100vh - 70px); /* Оставляем место для заголовка и правого меню */
  overflow-y: auto;
  opacity: 0.9;
  pointer-events: none; /* Не мешать кликам по канвасу */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.debug-info-menu h4 {
  margin: 0 0 5px 0;
  font-size: 11px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 3px;
  color: #ffffff;
}

.debug-info-menu div:not(.info-section) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1px 0;
}

.debug-info-menu .info-section {
  border-top: 1px dashed rgba(255, 255, 255, 0.15);
  margin-top: 4px;
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.debug-info-menu .info-section span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
} `, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/debug/DebugInfo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAE,UAAU;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,2BAA2B;EACrC,uCAAuC,EAAE,eAAe;EACxD,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc,EAAE,uBAAuB;EACvC,eAAe;EACf,8CAA8C,EAAE,uBAAuB;EACvE,gBAAgB;EAChB,8BAA8B,EAAE,iDAAiD;EACjF,gBAAgB;EAChB,YAAY;EACZ,oBAAoB,EAAE,gCAAgC;EACtD,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".debug-info-menu {\r\n  position: absolute;\r\n  top: 45px;\r\n  left: 10px; /* Слева */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px; /* Чуть больше промежуток */\r\n  background-color: rgba(20, 20, 20, 0.7); /* Темный фон */\r\n  padding: 8px;\r\n  border-radius: 5px;\r\n  z-index: 1000;\r\n  color: #e0e0e0; /* Светло-серый текст */\r\n  font-size: 10px;\r\n  font-family: 'Courier New', Courier, monospace; /* Моноширинный шрифт */\r\n  max-width: 200px;\r\n  max-height: calc(100vh - 70px); /* Оставляем место для заголовка и правого меню */\r\n  overflow-y: auto;\r\n  opacity: 0.9;\r\n  pointer-events: none; /* Не мешать кликам по канвасу */\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.debug-info-menu h4 {\r\n  margin: 0 0 5px 0;\r\n  font-size: 11px;\r\n  text-align: center;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n  padding-bottom: 3px;\r\n  color: #ffffff;\r\n}\r\n\r\n.debug-info-menu div:not(.info-section) {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding: 1px 0;\r\n}\r\n\r\n.debug-info-menu .info-section {\r\n  border-top: 1px dashed rgba(255, 255, 255, 0.15);\r\n  margin-top: 4px;\r\n  padding-top: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.debug-info-menu .info-section span {\r\n    display: block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
